var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { StyledTypography } from './StyledTypography';
import { spreadTransientProps } from '../../utils/transient';
import { useTheme } from '../ThemeProvider/useTheme';
const variantMapping = {
    largeTitle: 'h1',
    h1: 'h1',
    h2: 'h2',
    h3: 'h3',
    headline: 'h4',
    hugeBody: 'span',
    body: 'span',
    callout: 'span',
    footnote: 'span',
    caption: 'span',
    label: 'span',
};
export const typographyKeys = [
    'variant',
    'weight',
    'align',
    'color',
    'gradientColor',
    'title',
];
const TypographyComponent = (_a, ref) => {
    var { variant, color, component, underlineOptions } = _a, props = __rest(_a, ["variant", "color", "component", "underlineOptions"]);
    const theme = useTheme();
    const componentProps = component ? component : variantMapping[variant];
    return (_jsx(StyledTypography, Object.assign({ "$color": color, "$variant": variant, "$theme": theme, "$underlineOptions": underlineOptions, as: componentProps }, spreadTransientProps(props, typographyKeys), { ref: ref, children: underlineOptions ? _jsx("span", { children: props.children }) : props.children })));
};
export const Typography = forwardRef(TypographyComponent);
